/* ============================================================================
   Custom Quick Shop  (no template file required)
   ----------------------------------------------------------------------------
   Replaces Boost's broken quick view with our own modal. Flow:
     1. On load + on every Boost re-render, find each .boost-sd__button--quick-view,
        delete its data-metadata (disarming Boost's quick view), and bind our click.
     2. On click, read the product handle from the Boost card (data-product-handle).
     3. Fetch Shopify's built-in /products/{handle}.js and build the modal markup
        client-side (title, vendor, price, images, variants, tags->specs box).
     4. Inject into our own overlay, style via global CSS, wire interactions.
   Add to Cart routes to the existing custom cart drawer; Buy Now adds then goes
   to /checkout. Must load GLOBALLY (before </body> in theme.liquid).
   ============================================================================ */
(function () {
  'use strict';

  window.__qsReady = true; // marker: confirms this script executed (debug check)

  var MODAL_ID = 'qs-custom-modal';
  var _galleryNav = null; // set per-open in wireModal; used by the shell keydown for arrow keys
  var _cddSeq = 0; // unique ids for the custom dropdown's listbox + options (aria-controls / aria-activedescendant)
  var FOCUSABLE = 'a[href],button,input,select,textarea,iframe,summary,[tabindex]:not([tabindex="-1"])'; // same list as spd-a11y.js

  // Boost AI leftover, Boost is off.
//   /* -------- 1. neutralize Boost's quick-view button + bind our own --------
//      Boost triggers its (broken) quick view from the button's data-metadata.
//      We delete that attribute so Boost's handler has no action to run, then
//      attach our own click listener. This wins reliably instead of racing
//      Boost's event handler. Runs on load and on every Boost re-render. */
//   function processButtons(scope) {
//     var root = scope && scope.querySelectorAll ? scope : document;
//     var btns = root.querySelectorAll('.boost-sd__button--quick-view:not([data-qs-bound])');
//     Array.prototype.forEach.call(btns, function (btn) {
//       btn.setAttribute('data-qs-bound', '1');
//       try { btn.removeAttribute('data-metadata'); } catch (e) {}  // disarm Boost's quick view
//       btn.addEventListener('click', onQuickViewClick);
//     });
//   }
//
//   function onQuickViewClick(e) {
//     e.preventDefault();
//     e.stopPropagation();
//     if (e.stopImmediatePropagation) e.stopImmediatePropagation();
//     handleQuickViewButton(e.currentTarget || e.target);
//   }

  // Core handler, callable from either the per-button listener or the
  // document-level capture listener below.
  function handleQuickViewButton(btn) {
    if (!btn) return;
    var handle = getHandle(btn);
    if (!handle) {
      console.warn('[QuickShop] Could not resolve a product handle for this card.', btn);
      return;
    }
    var opts = {};
    var card = btn.closest('.boost-sd__product-item, [data-product], [data-product-id]');
    if (card) {
      // Boost AI leftover, Boost is off.
//       var priceEl = card.querySelector('.boost-sd__product-price--default .boost-sd__format-currency')
//                  || card.querySelector('.boost-sd__format-currency')
//                  || card.querySelector('.boost-sd__product-price-content');
//       if (priceEl) opts.priceText = priceEl.textContent.replace(/\s+/g, ' ').trim();
      var perEl = card.querySelector('.price-per-tb');
      if (perEl) opts.perText = perEl.textContent.replace(/\s+/g, ' ').trim();
      // Stock count: Shopify's /products/{handle}.js does NOT expose inventory,
      // so read it from Boost's card data (Boost tracks stock for in-stock
      // sorting/filtering). Best-effort; absent => no badge shown.
      var dp = card.getAttribute('data-product');
      if (dp) {
        try {
          var inv = readInventory(JSON.parse(dp));
          if (inv !== null) opts.inventory = inv;
        } catch (e) { /* malformed json */ }
      }
    }
    if (window.__qsDebug) console.log('[QuickShop] opening modal for:', handle, opts);
    openQuickShop(handle, opts);
  }

  // Pull a stock number out of Boost's product JSON, trying the common shapes.
  function readInventory(pj) {
    if (!pj || typeof pj !== 'object') return null;
    var keys = ['inventory_quantity', 'total_inventory', 'inventory', 'inventoryQuantity', 'totalInventory'];
    for (var k = 0; k < keys.length; k++) {
      if (typeof pj[keys[k]] === 'number' && isFinite(pj[keys[k]])) return pj[keys[k]];
    }
    if (Array.isArray(pj.variants) && pj.variants.length) {
      var sum = 0, found = false;
      for (var v = 0; v < pj.variants.length; v++) {
        var q = pj.variants[v] && pj.variants[v].inventory_quantity;
        if (typeof q === 'number' && isFinite(q)) { sum += q; found = true; }
      }
      if (found) return sum;
    }
    return null;
  }

  function getHandle(btn) {
    // Boost card: <div class="boost-sd__product-item" data-product-id data-product="{...}">
    // with a <a ... data-product-handle="..."> inside. Read the handle directly.
    var card = btn.closest('.boost-sd__product-item, [data-product], [data-product-id]');
    if (card) {
      var link = card.querySelector('[data-product-handle]');
      if (link && link.getAttribute('data-product-handle')) {
        return link.getAttribute('data-product-handle');
      }
      var dp = card.getAttribute('data-product');
      if (dp) {
        try {
          var json = JSON.parse(dp);
          if (json && json.handle) return json.handle;
        } catch (e) { /* malformed; fall through */ }
      }
      var a = card.querySelector('a[href*="/products/"]');
      if (a) {
        var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
        if (m) return m[1];
      }
    }
    // fallback: walk up looking for any /products/ link
    var node = btn;
    for (var i = 0; i < 10 && node; i++) {
      if (node.querySelector) {
        var aa = node.querySelector('a[href*="/products/"]');
        if (aa) {
          var mm = aa.getAttribute('href').match(/\/products\/([^/?#]+)/);
          if (mm) return mm[1];
        }
      }
      node = node.parentElement;
    }
    return null;
  }

  // PRIMARY interception: a single capture-phase listener on the document.
  // Matches BOTH Boost's quick-view button and the theme's own quick-shop
  // triggers (broad selector + a text fallback), so it works on every surface
  // — Boost collection grids AND theme-rendered carousels/related products.
  // Fires before the native handler regardless of when cards render, so it does
  // not depend on per-button binding (which other observers can starve).
  var QS_SELECTOR =
    // Boost AI leftover, Boost is off: '.boost-sd__button--quick-view, ' +
    '[data-quickshop], [data-quick-shop], [data-quick-shop-button], ' +
    '.quick-shop, .quickshop, .quick-shop-button, .quick-view, ' +
    '[class*="quick-shop" i], [class*="quickshop" i], [class*="quick-view" i]';

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest(QS_SELECTOR);
    if (!btn) {
      // text fallback: any short control labelled "Quick Shop" / "Quick View"
      var c = e.target.closest('a, button');
      if (c) {
        var label = ((c.getAttribute('aria-label') || '') + ' ' + (c.textContent || '')).trim();
        if (/quick\s*(shop|view)/i.test(label) && label.length < 40) btn = c;
      }
    }
    if (!btn) return;
    var handle = getHandle(btn);
    if (!handle) return; // not a resolvable product trigger — let the page handle it
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    handleQuickViewButton(btn);
  }, true);

  // Tell assistive tech the card triggers open a dialog. Grids re-render client-side
  // (sort, filter, paging), so re-run on DOM changes, coalesced to one pass per frame.
  var TRIGGER_SELECTOR = '[data-quickshop-trigger="full"], ' + QS_SELECTOR;
  function markTrigger(el) {
    if (el.matches('a, button') && !el.hasAttribute('aria-haspopup')) el.setAttribute('aria-haspopup', 'dialog');
  }
  // scope: an element to scan (itself and its subtree); no scope scans the whole document.
  function markTriggers(scope) {
    var root = scope || document;
    if (scope && scope.matches(TRIGGER_SELECTOR)) markTrigger(scope);
    Array.prototype.forEach.call(root.querySelectorAll(TRIGGER_SELECTOR), markTrigger);
  }
  if (document.readyState !== 'loading') markTriggers();
  else document.addEventListener('DOMContentLoaded', function () { markTriggers(); });
  // Only the added subtrees are scanned, once per frame; a large batch falls back to one full pass.
  var _mtQueued = false, _mtAdded = [];
  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) if (added[j].nodeType === 1) _mtAdded.push(added[j]);
    }
    if (_mtQueued || !_mtAdded.length) return;
    _mtQueued = true;
    requestAnimationFrame(function () {
      _mtQueued = false;
      var batch = _mtAdded; _mtAdded = [];
      if (batch.length > 200) { markTriggers(); return; }
      for (var k = 0; k < batch.length; k++) if (batch[k].isConnected) markTriggers(batch[k]);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  // Boost AI leftover, Boost is off.
//   // SECONDARY (defense in depth): strip Boost's data-metadata as cards render so
//   // its broken quick view has nothing to act on even if a click slips past.
//   // Throttled (not a resettable debounce) so continuous DOM churn from other
//   // observers can't starve it — it still runs at least every ~250ms.
//   if (document.readyState !== 'loading') processButtons();
//   else document.addEventListener('DOMContentLoaded', function () { processButtons(); });
//
//   var _pbLast = 0, _pbQueued = false;
//   function throttledProcess() {
//     var now = Date.now();
//     if (now - _pbLast >= 250) {
//       _pbLast = now;
//       processButtons();
//     } else if (!_pbQueued) {
//       _pbQueued = true;
//       setTimeout(function () {
//         _pbQueued = false;
//         _pbLast = Date.now();
//         processButtons();
//       }, 250 - (now - _pbLast));
//     }
//   }
//   new MutationObserver(throttledProcess)
//     .observe(document.documentElement, { childList: true, subtree: true });

  /* -------- 2. modal shell -------- */
  function buildShell() {
    var overlay = document.getElementById(MODAL_ID);
    if (overlay) return overlay;
    overlay = document.createElement('div');
    overlay.id = MODAL_ID;
    overlay.className = 'qs-overlay';
    overlay.innerHTML = '<div class="qs-dialog" role="dialog" aria-modal="true" aria-label="Quick shop" tabindex="-1"><div class="qs-dialog__body"></div></div>';
    document.body.appendChild(overlay);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeQuickShop(); });
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') { closeQuickShop(); return; }
      // Keep Tab inside the dialog while it is open. Only real tab stops count:
      // the backing <select> under each custom dropdown is tabindex="-1" and
      // aria-hidden, and the qty input / its list are display:none in turn.
      if (e.key === 'Tab') {
        var dialog = overlay.querySelector('.qs-dialog');
        var items = Array.prototype.filter.call(dialog.querySelectorAll(FOCUSABLE), function (el) {
          if (el.disabled || el.hidden || el.getAttribute('tabindex') === '-1') return false;
          if (el.closest('[aria-hidden="true"]')) return false;
          return el.offsetParent !== null || getComputedStyle(el).position === 'fixed';
        });
        if (!items.length) { e.preventDefault(); dialog.focus(); return; }
        var first = items[0], last = items[items.length - 1];
        var active = document.activeElement;
        if (!active || active === document.body || !dialog.contains(active)) { e.preventDefault(); first.focus(); }
        else if (e.shiftKey && (active === first || active === dialog)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
      }
      // Arrow keys inside a field move the caret or the value, not the gallery.
      if (e.target && e.target.closest && e.target.closest('input, select, textarea, [contenteditable], [role="combobox"]')) return;
      if (_galleryNav) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); _galleryNav.prev(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); _galleryNav.next(); }
      }
    });
    return overlay;
  }

  var _lastOpen = 0;
  var _qsOpener = null; // what had focus before the dialog opened, focus goes back there on close
  function openQuickShop(handle, opts) {
    var now = Date.now();
    if (now - _lastOpen < 400) return; // ignore rapid double-trigger
    _lastOpen = now;
    var overlay = buildShell();
    var body = overlay.querySelector('.qs-dialog__body');
    body.innerHTML = '<div class="qs-loading">Loading\u2026</div>';
    // Force a reflow so the (hidden) initial state is committed before we add
    // .is-open — otherwise the very first open would jump instead of fading.
    void overlay.offsetWidth;
    overlay.classList.add('is-open');
    var active = document.activeElement;
    _qsOpener = active && active !== document.body && !overlay.contains(active) ? active : null;
    var dialog = overlay.querySelector('.qs-dialog');
    dialog.setAttribute('aria-label', 'Quick shop');
    try { dialog.focus(); } catch (e) {}

    opts = opts || {};

    // Live stock count comes from a tiny server-rendered view (product.stock.liquid),
    // because Shopify's /products/{handle}.js doesn't expose inventory. Fetched in
    // parallel; failures degrade gracefully (badge just won't show a number).
    var stockPromise = fetch('/products/' + encodeURIComponent(handle) + '?view=stock', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) { if (!t) return null; try { return JSON.parse(t.trim()); } catch (e) { return null; } })
      .catch(function () { return null; });

    fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('product fetch failed');
        return r.json();
      })
      .then(function (product) {
        return stockPromise.then(function (stock) {
          opts.stock = stock;
          body.innerHTML = buildModalHTML(product, handle, opts);
          wireModal(body);
        });
      })
      .catch(function () {
        body.innerHTML = '<div class="qs-loading">Couldn\u2019t load this product. ' +
          '<a href="/products/' + handle + '">View full details</a></div>';
      });
  }

  /* -------- build the modal markup from /products/{handle}.js -------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function activeCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  }
  // IMPORTANT: /products/{handle}.js on this store already returns prices in the
  // ACTIVE presentment currency (this is what the storefront's card price
  // band-aid relies on too). So we format the cents as-is and must NOT multiply
  // by Shopify.currency.rate — doing so would double-convert and underprice.
  function money(cents) {
    var amt = (parseInt(cents, 10) || 0) / 100;
    var cur = activeCurrency();
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(amt);
    } catch (e) {
      return amt.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + cur;
    }
  }
  // Hard drives read per TB. SSDs read per GB: cents with one decimal in USD (8.3¢), money elsewhere.
  function pricePer(cents, capTB, isSsd) {
    if (!isSsd) return 'Price per TB: ' + money(cents / capTB);
    var perGb = cents / capTB / 1000;
    if (activeCurrency() === 'USD' && perGb < 100) return 'Price per GB: ' + perGb.toFixed(1) + '\u00a2';
    return 'Price per GB: ' + money(perGb);
  }
  function imgUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function capacityTB(capStr) {
    if (!capStr) return null;
    var num = parseFloat(capStr);
    if (isNaN(num)) return null;
    return /gb/i.test(capStr) ? num / 1000 : num; // GB -> TB, else assume TB
  }
  function tagMap(tags) {
    var map = {};
    (tags || []).forEach(function (t) {
      var i = String(t).indexOf(':');
      if (i === -1) return;
      var k = t.slice(0, i).trim();
      var v = t.slice(i + 1).trim().split(',')[0].trim(); // strip accidental joined tags
      if (!(k in map)) map[k] = v;
    });
    return map;
  }
  function specsTable(map) {
    var rows = [];
    if (map.capacity) rows.push(['Capacity', map.capacity]);
    if (map.interface) rows.push(['Interface', map.interface + (map.interfaceSpeed ? ' ' + map.interfaceSpeed : '')]);
    if (map.formFactor) rows.push(['Form Factor', /["\u201d]/.test(map.formFactor) ? map.formFactor : map.formFactor + '"']);
    if (map.spindleSpeed) rows.push(['Spindle Speed', map.spindleSpeed]);
    if (map.endurance) rows.push(['Endurance', map.endurance]);
    if (map.condition) rows.push(['Condition', map.condition]);
    if (map.warranty) rows.push(['Warranty', map.warranty]);
    if (!rows.length) return '';
    var h = '<table class="metafield-description-table"><tbody>';
    rows.forEach(function (r) {
      h += '<tr><th scope="row">' + esc(r[0]) + '</th><td>' + esc(r[1]) + '</td></tr>';
    });
    return h + '</tbody></table>';
  }

  function buildModalHTML(product, handle, opts) {
    opts = opts || {};
    var map = tagMap(product.tags);
    var images = product.images && product.images.length ? product.images : (product.featured_image ? [product.featured_image] : []);
    var mainSrc = imgUrl(images[0] || product.featured_image, 800);

    // pick first available variant, else first
    var variant = null, i;
    for (i = 0; i < (product.variants || []).length; i++) {
      if (product.variants[i].available) { variant = product.variants[i]; break; }
    }
    if (!variant) variant = (product.variants || [])[0] || null;
    var available = variant ? variant.available : false;
    var variantId = variant ? variant.id : '';
    var price = variant ? variant.price : product.price;

    // Price + price-per-TB in the active presentment currency.
    // Prefer Shopify's own currency state (active + rate) so it matches the rest
    // of the storefront. Fall back to the card text, then to a plain shop-currency
    // format, only if Shopify.currency isn't present.
    var capTB = capacityTB(map.capacity);
    var isSsd = /solid state/i.test(map.type || '');
    var priceDisplay, perTB = '';
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      priceDisplay = money(price);
      if (capTB && capTB > 0) perTB = pricePer(price, capTB, isSsd);
    } else if (opts.priceText) {
      priceDisplay = opts.priceText;
      perTB = opts.perText || '';
    } else {
      priceDisplay = money(price);
      if (capTB && capTB > 0) perTB = pricePer(price, capTB, isSsd);
    }

    var thumbs = '';
    if (images.length > 1) {
      thumbs = '<div class="qs-pdp__thumbs">' + images.map(function (src, idx) {
        return '<button type="button" class="qs-pdp__thumb' + (idx === 0 ? ' is-active' : '') +
          '" aria-label="Image ' + (idx + 1) + ' of ' + images.length + '"' + (idx === 0 ? ' aria-current="true"' : '') +
          ' data-full="' + esc(imgUrl(src, 800)) + '"><img src="' + esc(imgUrl(src, 160)) + '" alt="" loading="lazy"></button>';
      }).join('') + '</div>';
    }

    var navHTML = '';
    if (images.length > 1) {
      navHTML =
        '<button type="button" class="qs-pdp__nav qs-pdp__nav--prev" aria-label="Previous image">' +
          '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg>' +
        '</button>' +
        '<button type="button" class="qs-pdp__nav qs-pdp__nav--next" aria-label="Next image">' +
          '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg>' +
        '</button>';
    }

    var buyHTML;
    if (available) {
      buyHTML =
        '<button type="button" class="qs-atc">Add To Cart</button>' +
        '<button type="button" class="qs-buynow">Buy Now</button>';
    } else {
      buyHTML =
        '<button type="button" class="qs-atc" disabled>Sold Out</button>' +
        '<a class="qs-buynow qs-notify" href="/products/' + esc(handle) + '#notify">Notify me when available</a>';
    }

    var qtyOpts = '';
    for (i = 1; i <= 9; i++) qtyOpts += '<option value="' + i + '">' + i + '</option>';
    qtyOpts += '<option value="10" data-plus="1">10+</option>';

    // Stock badge — mirror the PDP's logic exactly, using the live count from
    // the stock view (matched to the chosen variant). Falls back to the Boost
    // card count if the stock view wasn't available; hides if nothing is known.
    var qtyNum = null, tracked = false, vAvail = available;
    if (opts.stock && Array.isArray(opts.stock.variants)) {
      for (var s = 0; s < opts.stock.variants.length; s++) {
        if (String(opts.stock.variants[s].id) === String(variantId)) {
          qtyNum = opts.stock.variants[s].qty;
          tracked = !!opts.stock.variants[s].tracked;
          vAvail = opts.stock.variants[s].available;
          break;
        }
      }
    }
    if (qtyNum === null && typeof opts.inventory === 'number' && isFinite(opts.inventory)) {
      qtyNum = opts.inventory; tracked = true;
    }

    var invBadge = '', stockClass = '', stockText = '';
    if (!vAvail) {
      stockClass = 'qs-pdp__stock--out'; stockText = 'Out of stock';
    } else if (qtyNum === null) {
      stockText = ''; // unknown — show nothing rather than a fake number
    } else if (!tracked || qtyNum > 10) {
      stockClass = 'qs-pdp__stock--in'; stockText = qtyNum > 0 ? (qtyNum + ' in stock') : 'In stock';
    } else if (qtyNum > 0) {
      stockClass = 'qs-pdp__stock--low'; stockText = 'Only ' + qtyNum + ' left';
    } else {
      stockClass = 'qs-pdp__stock--in'; stockText = 'In stock';
    }
    if (stockText) {
      var icon = (stockClass === 'qs-pdp__stock--out')
        ? '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M15 9l-6 6M9 9l6 6"></path></svg>'
        : '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M8.5 12.4l2.4 2.4 4.6-5.2"></path></svg>';
      invBadge = '<span class="qs-pdp__stock ' + stockClass + '">' + icon + '<span>' + esc(stockText) + '</span></span>';
    }

    // Cap the editable qty input at the real stock (only when tracked & known).
    var stockAttr = (typeof qtyNum === 'number' && tracked && qtyNum > 0) ? esc(String(qtyNum)) : '';

    var specsHTML = specsTable(map);
    var specsBlock = specsHTML ? ('<div class="qs-pdp__specs">' + specsHTML + '</div>') : '';
    var perBlock = perTB ? ('<span class="qs-pdp__price-per">' + esc(perTB) + '</span>') : '';

    return '' +
      '<div class="qs-pdp" data-product-handle="' + esc(handle) + '">' +
        '<button type="button" class="qs-pdp__close" aria-label="Close">&times;</button>' +
        '<div class="qs-pdp__gallery">' +
          '<div class="qs-pdp__main"><img id="qsMainImage" class="qs-pdp__mainimg" src="' + esc(mainSrc) + '" alt="' + esc(product.title) + '">' + navHTML + '</div>' +
          thumbs +
        '</div>' +
        '<div class="qs-pdp__info">' +
          '<h2 id="qs-title" class="qs-pdp__title">' + esc(product.title) + '</h2>' +
          '<div class="qs-pdp__vendor">' + esc(product.vendor) + '</div>' +
          '<div class="qs-pdp__price">' +
            '<div class="qs-pdp__price-top">' +
              '<span class="qs-pdp__price-amount">' + esc(priceDisplay) + '</span>' +
              invBadge +
            '</div>' +
            perBlock +
          '</div>' +
          specsBlock +
          '<div class="qs-pdp__buy" data-variant-id="' + esc(variantId) + '" data-available="' + available + '" data-stock="' + stockAttr + '">' +
            '<div class="qs-pdp__qtyrow"><div class="pdp-qty-field">' +
              '<span class="pdp-qty-prefix">Quantity :</span>' +
              '<select class="qs-qty" aria-label="Quantity">' + qtyOpts + '</select>' +
              '<span class="qs-qty-input-wrap" hidden>' +
                '<input type="number" class="qs-qty-input" min="1" step="1" value="10" inputmode="numeric" aria-label="Enter quantity">' +
                '<button type="button" class="qs-qty-back" aria-label="Choose quantity from list" title="Back to list">\u2039</button>' +
              '</span>' +
            '</div></div>' +
            buyHTML +
            '<p class="qs-stocknote" role="status" aria-live="polite" hidden></p>' +
          '</div>' +
          '<a class="qs-pdp__viewfull" href="/products/' + esc(handle) + '">View full details</a>' +
        '</div>' +
      '</div>';
  }

  function closeQuickShop() {
    var overlay = document.getElementById(MODAL_ID);
    if (!overlay) return;
    _galleryNav = null;
    overlay.classList.remove('is-open');
    var back = _qsOpener;
    _qsOpener = null;
    if (overlay.contains(document.activeElement) || document.activeElement === document.body) {
      try {
        if (back && document.contains(back)) {
          // Card actions hide again once the pointer leaves, so the opener may not be
          // focusable any more; land on the card's product link instead.
          if (back.offsetParent === null || getComputedStyle(back).visibility === 'hidden') {
            var card = back.closest('.productitem, .productgrid--item, .spd-card');
            var link = card && card.querySelector('a[href]');
            if (link) back = link;
          }
          back.focus();
        }
      } catch (e) {}
    }
    // Clear content only after the fade-out completes, and only if it wasn't
    // reopened in the meantime (otherwise we'd wipe the new modal's content).
    setTimeout(function () {
      if (!overlay.classList.contains('is-open')) {
        var body = overlay.querySelector('.qs-dialog__body');
        if (body) body.innerHTML = '';
      }
    }, 320);
  }

  /* -------- 3. wire the injected content -------- */
  function wireModal(root) {
    var closeBtn = root.querySelector('.qs-pdp__close');
    if (closeBtn) closeBtn.addEventListener('click', closeQuickShop);
    var dialog = root.closest('.qs-dialog');
    var titleEl = root.querySelector('.qs-pdp__title, h2, h3');
    if (dialog && titleEl) dialog.setAttribute('aria-label', 'Quick shop: ' + titleEl.textContent.replace(/\s+/g, ' ').trim());
    if (dialog && document.activeElement && !dialog.contains(document.activeElement)) { try { dialog.focus(); } catch (e) {} }

    // gallery: thumbnails + prev/next arrows share one crossfade navigator
    var mainBox = root.querySelector('.qs-pdp__main');
    var mainImg = root.querySelector('#qsMainImage');
    var galThumbs = Array.prototype.slice.call(root.querySelectorAll('.qs-pdp__thumb'));
    var fulls = galThumbs.map(function (t) { return t.getAttribute('data-full'); });
    var current = 0;
    var transitioning = false;

    function setActiveThumb(i) {
      galThumbs.forEach(function (t, idx) {
        t.classList.toggle('is-active', idx === i);
        if (idx === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }

    function goTo(i) {
      if (!fulls.length || !mainBox) return;
      i = ((i % fulls.length) + fulls.length) % fulls.length; // wrap
      if (i === current && mainImg && mainImg.getAttribute('src') === fulls[i]) { setActiveThumb(i); return; }
      if (transitioning) return;
      var full = fulls[i];
      if (!full) { current = i; setActiveThumb(i); return; }
      transitioning = true;
      current = i;
      setActiveThumb(i);

      var incoming = document.createElement('img');
      incoming.className = 'qs-pdp__mainimg qs-pdp__mainimg--incoming';
      incoming.alt = mainImg ? mainImg.alt : '';
      incoming.src = full;
      mainBox.appendChild(incoming);

      function reveal() {
        requestAnimationFrame(function () { incoming.classList.add('is-shown'); });
        setTimeout(function () {
          if (mainImg && mainImg.parentNode) mainImg.parentNode.removeChild(mainImg);
          incoming.id = 'qsMainImage';
          incoming.classList.remove('qs-pdp__mainimg--incoming', 'is-shown');
          mainImg = incoming;
          transitioning = false;
        }, 240); // a touch longer than the CSS fade
      }
      if (incoming.complete) reveal();
      else {
        incoming.onload = reveal;
        incoming.onerror = function () {
          if (incoming.parentNode) incoming.parentNode.removeChild(incoming);
          if (mainImg) mainImg.src = full;
          transitioning = false;
        };
      }
    }

    galThumbs.forEach(function (thumb, idx) {
      thumb.addEventListener('click', function () { goTo(idx); });
    });
    var prevBtn = root.querySelector('.qs-pdp__nav--prev');
    var nextBtn = root.querySelector('.qs-pdp__nav--next');
    if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); goTo(current + 1); });
    // expose for keyboard arrows (handled by the shell's single keydown listener)
    _galleryNav = (fulls.length > 1)
      ? { prev: function () { goTo(current - 1); }, next: function () { goTo(current + 1); } }
      : null;

    // qty -> custom pill dropdown, with "10+" swapping to an editable input
    var qtyField = root.querySelector('.pdp-qty-field');
    var qtySel = root.querySelector('.qs-qty');
    if (qtySel) buildCustomDropdown(qtySel);
    var cdd = qtyField ? qtyField.querySelector('.pdp-cdd') : null;
    var inputWrap = qtyField ? qtyField.querySelector('.qs-qty-input-wrap') : null;
    var qtyInput = inputWrap ? inputWrap.querySelector('.qs-qty-input') : null;
    var qtyBack = inputWrap ? inputWrap.querySelector('.qs-qty-back') : null;

    var buy = root.querySelector('.qs-pdp__buy');
    var variantId = buy ? buy.getAttribute('data-variant-id') : null;
    var stockNum = buy ? parseInt(buy.getAttribute('data-stock'), 10) : NaN;
    var hasStock = !isNaN(stockNum) && stockNum > 0;
    if (qtyInput && hasStock) qtyInput.setAttribute('max', String(stockNum));

    var noteEl = root.querySelector('.qs-stocknote');
    function clearNote() { if (noteEl) { noteEl.hidden = true; noteEl.innerHTML = ''; } }
    function showNote(html) { if (noteEl) { noteEl.innerHTML = html; noteEl.hidden = false; } }
    // Live "more than we have" warning — fires while the qty is being edited.
    function warnOver(requested) {
      if (hasStock && requested > stockNum) {
        showNote('We have <strong>' + stockNum + '</strong> units in stock and ready to ship online. ' +
          'Additional inventory is typically available. ' +
          '<a href="/pages/contact-us">Contact our sales team</a> to order directly.');
        return true;
      }
      return false;
    }

    function clampInput() {
      if (!qtyInput) return;
      var n = parseInt(qtyInput.value, 10);
      if (!n || n < 1) n = 1; // only enforce a sane floor; let the value stay
      qtyInput.value = String(n); // visible so they keep what they typed
      if (!warnOver(n)) clearNote();
    }
    function toInputMode() {
      if (cdd) cdd.style.display = 'none';
      if (inputWrap) inputWrap.hidden = false;
      if (qtyInput) {
        var start = 10;
        if (hasStock && start > stockNum) start = stockNum;
        qtyInput.value = String(start);
        try { qtyInput.focus(); qtyInput.select(); } catch (e) {}
      }
      clearNote();
    }
    function toListMode() {
      if (inputWrap) inputWrap.hidden = true;
      if (cdd) cdd.style.display = '';
      if (qtySel) {
        qtySel.selectedIndex = 0;
        if (typeof qtySel._cddRefresh === 'function') qtySel._cddRefresh();
      }
      // The back button just hid itself; land on the dropdown, not <body>.
      var display = cdd ? cdd.querySelector('.pdp-cdd-display') : null;
      if (display) { try { display.focus(); } catch (e) {} }
      clearNote();
    }
    if (qtySel) {
      qtySel.addEventListener('change', function () {
        var opt = qtySel.options[qtySel.selectedIndex];
        if (opt && opt.getAttribute('data-plus')) { toInputMode(); return; }
        var v = parseInt(qtySel.value, 10);
        if (!warnOver(v)) clearNote();
      });
    }
    if (qtyInput) {
      qtyInput.addEventListener('input', function () {
        var n = parseInt(qtyInput.value, 10) || 0;
        if (!warnOver(n)) clearNote();
      });
      qtyInput.addEventListener('change', clampInput);
      qtyInput.addEventListener('blur', clampInput);
    }
    if (qtyBack) qtyBack.addEventListener('click', toListMode);

    // requested qty WITHOUT the stock cap, so we can tell when we had to cap
    function getRawQty() {
      if (inputWrap && !inputWrap.hidden) {
        var n = parseInt(qtyInput && qtyInput.value, 10);
        return (!n || n < 1) ? 1 : n;
      }
      var v = parseInt(qtySel && qtySel.value, 10);
      return v && v > 0 ? v : 1;
    }

    function handleAdd(btn, checkout) {
      clearNote();
      var requested = getRawQty();
      var qty = requested, wasCapped = false;
      if (hasStock && requested > stockNum) { qty = stockNum; wasCapped = true; }
      if (qty < 1) qty = 1;
      addToCart(variantId, qty, btn, checkout, { capped: wasCapped, stock: stockNum, showNote: showNote });
    }

    var atc = root.querySelector('.qs-atc');
    if (atc && !atc.disabled) {
      atc.addEventListener('click', function () { handleAdd(atc, false); });
    }
    var buynow = root.querySelector('.qs-buynow:not(.qs-notify)');
    if (buynow) {
      buynow.addEventListener('click', function () { handleAdd(buynow, true); });
    }
  }

  function addToCart(variantId, qty, btn, checkout, opts) {
    opts = opts || {};
    if (!variantId) return;
    var orig = btn.textContent;
    btn.textContent = checkout ? 'Processing\u2026' : 'Adding\u2026';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    })
      .then(function (r) {
        if (!r.ok) {
          // Shopify returns 422 with a JSON description when stock is exceeded
          // (e.g. the item is already in the cart at/near its limit).
          return r.json().then(function (err) { throw { shopify: err }; }, function () { throw new Error('add failed'); });
        }
        return r.json();
      })
      .then(function () {
        // We capped the quantity down to what's in stock — keep the modal open
        // so the shopper actually sees the note, and don't barrel into checkout.
        if (opts.capped) {
          btn.textContent = orig;
          btn.disabled = false;
          if (typeof opts.showNote === 'function') {
            opts.showNote(
              'We\u2019ve added all <strong>' + opts.stock + '</strong> units in stock to your cart \u2014 ready to ' +
              'ship online. Additional inventory is typically available. ' +
              '<a href="/pages/contact-us">Contact our sales team</a> to order directly.'
            );
          }
          document.dispatchEvent(new CustomEvent('cart:updated'));
          return;
        }
        if (checkout) { window.location.href = '/checkout'; return; }
        closeQuickShop();
        if (window.CustomCartDrawer && typeof window.CustomCartDrawer.open === 'function') {
          window.CustomCartDrawer.open();
        } else {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('product:added'));
        }
      })
      .catch(function (e) {
        btn.textContent = orig;
        btn.disabled = false;
        var desc = e && e.shopify && (e.shopify.description || e.shopify.message);
        if (desc && typeof opts.showNote === 'function') {
          opts.showNote(
            esc(desc) + ' If you need more, please <a href="/pages/contact-us">contact our sales team</a>.'
          );
        }
      });
  }

  /* -------- custom .pdp-cdd dropdown (qty) -------- */
  function buildCustomDropdown(selectEl) {
    if (!selectEl || selectEl.tagName !== 'SELECT' || selectEl.dataset.pdpCdd === '1') return;
    selectEl.dataset.pdpCdd = '1';

    var wrapper = document.createElement('div');
    wrapper.className = 'pdp-cdd pdp-cdd--qty';
    selectEl.parentNode.insertBefore(wrapper, selectEl);
    wrapper.appendChild(selectEl);

    selectEl.addEventListener('mousedown', function (e) { e.preventDefault(); }, true);
    // The select stays in the DOM (its value is what gets read), but the display
    // below is the only tab stop and the only thing assistive tech sees.
    selectEl.setAttribute('tabindex', '-1');
    selectEl.setAttribute('aria-hidden', 'true');

    var display = document.createElement('div');
    display.className = 'pdp-cdd-display';
    display.tabIndex = 0;
    display.setAttribute('role', 'combobox');
    display.setAttribute('aria-haspopup', 'listbox');
    display.setAttribute('aria-expanded', 'false');
    display.setAttribute('aria-label', selectEl.getAttribute('aria-label') || 'Quantity');
    function refresh() {
      var i = selectEl.selectedIndex;
      display.textContent = (selectEl.options[i] && selectEl.options[i].text) || '';
    }
    selectEl._cddRefresh = refresh; // allow external resync (e.g. "back to list")
    refresh();
    wrapper.appendChild(display);

    var menu = document.createElement('div');
    menu.className = 'pdp-cdd-menu';
    menu.id = 'qs-cdd-menu-' + (++_cddSeq);
    menu.setAttribute('role', 'listbox');
    menu.hidden = true;
    document.body.appendChild(menu);
    display.setAttribute('aria-controls', menu.id);

    // Keyboard cursor while the list is open. The .selected class doubles as its visual.
    var hi = -1;
    function highlight(i) {
      var items = menu.children;
      if (!items.length) return;
      i = Math.max(0, Math.min(items.length - 1, i));
      Array.prototype.forEach.call(items, function (c, idx) {
        c.classList.toggle('selected', idx === i);
        c.setAttribute('aria-selected', idx === i ? 'true' : 'false');
      });
      hi = i;
      display.setAttribute('aria-activedescendant', items[i].id);
      if (items[i].scrollIntoView) items[i].scrollIntoView({ block: 'nearest' });
    }

    function rebuild() {
      menu.innerHTML = '';
      Array.from(selectEl.options).forEach(function (opt, i) {
        var item = document.createElement('div');
        item.className = 'pdp-cdd-option';
        item.id = menu.id + '-opt-' + i;
        item.dataset.index = i;
        item.textContent = opt.text;
        item.setAttribute('role', 'option');
        menu.appendChild(item);
      });
      highlight(selectEl.selectedIndex);
    }
    function position() {
      var rect = display.getBoundingClientRect();
      var width = Math.max(110, Math.min(220, Math.round(rect.width) + 28));
      var left = Math.round(rect.left);
      var top = Math.round(rect.bottom + 8);
      if (left + width > window.innerWidth - 8) left = Math.max(8, window.innerWidth - width - 8);
      var mh = Math.min(menu.scrollHeight || 220, 220);
      if (top + mh > window.innerHeight - 8) {
        var up = Math.round(rect.top - mh - 8);
        if (up > 8) top = up;
      }
      menu.style.setProperty('width', width + 'px', 'important');
      menu.style.setProperty('left', left + 'px', 'important');
      menu.style.setProperty('top', top + 'px', 'important');
    }
    function close() {
      menu.hidden = true;
      display.setAttribute('aria-expanded', 'false');
      display.removeAttribute('aria-activedescendant');
      wrapper.classList.remove('pdp-cdd--open');
    }
    function open() {
      document.querySelectorAll('body > .pdp-cdd-menu').forEach(function (m) { m.hidden = true; });
      rebuild(); menu.hidden = false;
      display.setAttribute('aria-expanded', 'true');
      wrapper.classList.add('pdp-cdd--open');
      requestAnimationFrame(position);
    }
    function pick(idx) {
      selectEl.selectedIndex = idx;
      refresh();
      highlight(idx);
      close();
      selectEl.dispatchEvent(new Event('change', { bubbles: true }));
    }
    display.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); menu.hidden ? open() : close(); });
    display.addEventListener('keydown', function (e) {
      var isOpen = !menu.hidden;
      var last = selectEl.options.length - 1;
      var cur = isOpen ? hi : selectEl.selectedIndex;
      var next = e.key === 'ArrowDown' ? Math.min(last, cur + 1)
        : e.key === 'ArrowUp' ? Math.max(0, cur - 1)
        : e.key === 'Home' ? 0
        : e.key === 'End' ? last : -1;
      if (next > -1) {
        e.preventDefault();
        if (isOpen) highlight(next);
        else if (next !== cur) pick(next); // closed: step the value like a native select
      } else if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (isOpen) pick(hi); else open();
      } else if (e.key === 'Escape') {
        if (isOpen) { e.stopPropagation(); close(); } // only the list closes, not the quick shop
      } else if (e.key === 'Tab' && isOpen) {
        pick(hi);
      }
    });
    menu.addEventListener('click', function (e) {
      var opt = e.target.closest('.pdp-cdd-option');
      if (!opt) return;
      pick(parseInt(opt.dataset.index, 10));
    });
    window.addEventListener('scroll', function () { if (!menu.hidden) position(); }, true);
    window.addEventListener('resize', function () { if (!menu.hidden) position(); });
    document.addEventListener('click', function (e) {
      if (e.target.closest('.pdp-cdd') || e.target.closest('.pdp-cdd-menu')) return;
      close();
    });
  }
})();
